(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sh-autoship"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sh-autoship')) {
  customElements.define('sh-autoship', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.data = JSON.parse(this.querySelector('template').content.textContent); } catch (_) { return; }
      this.table = this.dataset.table === 'true';
      this.scope = this.table ? this.closest('[data-section-type="product-page"]') : this.closest('form');
      if (!this.scope) return;
      this.once = this.querySelector('input[value="once"]');
      this.repeat = this.querySelector('input[value="repeat"]');
      this.frequency = this.querySelector('[data-frequency]');
      const group = 'sh_purchase_' + crypto.randomUUID();
      this.once.name = this.repeat.name = group;
      this.addEventListener('change', () => this.sync());
      if (!this.table) {
        this.observer = new MutationObserver(() => this.sync());
        const variant = this.scope.querySelector('[data-js-product-variant-input]');
        if (variant) this.observer.observe(variant, {attributes:true, attributeFilter:['value']});
        this.scope.addEventListener('change', this.variantListener = () => this.sync());
      }
      if (this.data.required) this.repeat.checked = true;
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.variantListener) this.scope?.removeEventListener('change', this.variantListener);
    }
    variant(form) {
      const field = form.querySelector('[name="id"]');
      const id = field?.value || form.querySelector('[data-js-product-variant-input]')?.value;
      return this.data.variants.find(variant => String(variant.id) === String(id));
    }
    sync() {
      const forms = this.table ? [...this.scope.querySelectorAll('.sh-product-page-form')] : [this.scope];
      const variants = forms.map(form => this.variant(form)).filter(Boolean);
      const plans = [...new Map(variants.flatMap(variant => variant.plans.filter(plan => plan.recurring)).map(plan => [String(plan.id), plan])).values()];
      const previous = this.frequency.value;
      this.frequency.replaceChildren(...plans.map(plan => new Option(plan.name, String(plan.id))));
      if (plans.some(plan => String(plan.id) === previous)) this.frequency.value = previous;
      const active = this.repeat.checked;
      this.hidden = !plans.length && !active;
      this.repeat.disabled = !plans.length;
      this.querySelector('.sh-autoship__schedule').hidden = !active;
      let missing = false;
      for (const form of forms) {
        const variant = this.variant(form);
        const allocation = variant?.plans.find(plan => plan.recurring && String(plan.id) === this.frequency.value);
        let input = form.querySelector('input[name="selling_plan"]');
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'selling_plan'; form.append(input); }
        input.disabled = !active || !allocation;
        input.value = active && allocation ? String(allocation.id) : '';
        const unsupported = active && !allocation;
        form.dataset.shAutoshipBlocked = String(unsupported);
        form.querySelectorAll('[data-js-product-button-add-to-cart],button[name="add"]').forEach(button => {
          if (unsupported && !button.disabled) { button.dataset.shAutoshipDisabled = 'true'; button.disabled = true; }
          if (!unsupported && button.dataset.shAutoshipDisabled) { delete button.dataset.shAutoshipDisabled; if (button.dataset.buttonStatus !== 'sold-out') button.disabled = false; }
        });
        let note = form.querySelector('.sh-autoship-unavailable');
        if (unsupported && !note) { note = document.createElement('p'); note.className = 'sh-autoship-unavailable'; note.textContent = this.dataset.unavailable; form.append(note); }
        if (note) note.hidden = !unsupported;
        missing ||= unsupported;
        form.querySelectorAll('.shopify-payment-button').forEach(button => { button.hidden = active; });
        const price = form.closest('[data-sh-variant-row]')?.querySelector('[data-sh-autoship-price]');
        if (price) { price.dataset.oneTimePrice ||= price.textContent; price.textContent = active && allocation ? allocation.price : price.dataset.oneTimePrice; }
      }
      const status = this.querySelector('[data-autoship-status]');
      status.hidden = !missing;
      status.textContent = missing ? this.dataset.unavailable : '';
      const allocation = variants[0]?.plans.find(plan => String(plan.id) === this.frequency.value);
      this.querySelector('[data-recurring-price]').textContent = !this.table && active && allocation ? allocation.price + ' · ' + allocation.name : '';
    }
  });
  document.addEventListener('submit', event => {
    if (event.target.dataset.shAutoshipBlocked === 'true') event.preventDefault();
  }, true);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-size-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-sh-size-finder]').forEach(section => {
      if(section.dataset.shReady)return;section.dataset.shReady='true';
      const form=section.querySelector('form'), status=section.querySelector('[data-sh-finder-status]'), results=section.querySelector('[data-sh-finder-results]'), more=section.querySelector('[data-sh-finder-more]');
      let catalogPromise, matches=[],offset=0, generation=0, current, activeRange='', rangeSubmit=false;
      const cache=new Map();
      const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:document.querySelector('[data-sh-store-currency]')?.dataset.shStoreCurrency||'USD'});
      const root=section.dataset.productsRoot;
      function count(v){let s=String(v).replaceAll(',','');const cases=s.match(/^(\d+) Cases (\d+)\/cs/);if(cases)return Number(cases[1])*Number(cases[2]);const single=s.match(/^Case \((\d+)\)/);if(single)return Number(single[1]);return /^\d+(?:\s|$)/.test(s)?parseFloat(s):null;}
      async function product(handle){if(!cache.has(handle))cache.set(handle,fetch(`${root}products/${handle}.js`).then(r=>{if(r.status===404)return null;if(!r.ok)throw Error();return r.json();}).catch(e=>{cache.delete(handle);throw e;}));return cache.get(handle);}
      async function loadBatch(token){
        more.hidden=true;form.querySelector('button').disabled=true;
        const batch=matches.slice(offset,offset+12);offset+=batch.length;
        let failed=0;
        for(let i=0;i<batch.length;i+=3){
          const resolved=await Promise.allSettled(batch.slice(i,i+3).map(async item=>({item,p:await product(item.handle)})));
          if(token!==generation)return;
          for(const row of resolved){
            if(row.status!=='fulfilled'){failed++;continue;}
            const {item,p}=row.value;if(!p)continue;
            const qIndex=p.options.findIndex(o=>['quantity','rolls'].includes((typeof o==='string'?o:o.name).toLowerCase()));
            const eligible=p.variants.filter(v=>(!current.quantity||(qIndex>=0&&count(v.options[qIndex])===current.quantity)||(p.variants.length===1&&item.quantities.includes(current.quantity)))&&(!current.stock||v.available));
            if(!eligible.length)continue;
            const v=eligible.find(v=>v.available)||eligible[0];
            const card=document.createElement('article');card.className='sh-finder-card';
            const url=`${root}products/${item.handle}?variant=${v.id}`;
            if(p.featured_image){const img=document.createElement('img');img.src=p.featured_image;img.alt=p.title;img.loading='lazy';card.append(img);}
            const title=document.createElement('a');title.href=url;title.textContent=p.title;card.append(title);
            const pack=document.createElement('span');pack.textContent=`${v.public_title||''} · ${money.format(v.price/100)}`;card.append(pack);
            const stock=document.createElement('span');stock.textContent=v.available?section.dataset.stockLabel:section.dataset.soldLabel;card.append(stock);
            const link=document.createElement('a');link.href=url;link.className='sh-finder-link';link.textContent=section.dataset.viewLabel;card.append(link);results.append(card);
          }
        }
        if(token!==generation)return;
        status.textContent=results.childElementCount?`${results.childElementCount} ${section.dataset.resultLabel}`:offset<matches.length?section.dataset.resultLabel:section.dataset.emptyLabel;
        if(failed)status.textContent+=' '+section.dataset.errorLabel;
        more.hidden=offset>=matches.length;form.querySelector('button').disabled=false;
      }
      form.addEventListener('submit',async e=>{
        e.preventDefault();if(!rangeSubmit){activeRange='';section.querySelectorAll('[data-sh-range]').forEach(b=>b.setAttribute('aria-pressed','false'));}rangeSubmit=false;const token=++generation;results.replaceChildren();more.hidden=true;offset=0;status.textContent='';form.querySelector('button').disabled=true;
        current={kind:form.elements.kind.value,length:Number(form.elements.namedItem('length').value),width:Number(form.elements.width.value),height:Number(form.elements.height.value),quantity:Number(form.elements.quantity.value),color:form.elements.color.value,stock:form.elements.stock.checked};
        try{
          if(!catalogPromise)catalogPromise=fetch(section.dataset.indexUrl).then(r=>{if(!r.ok)throw Error();return r.json();}).catch(e=>{catalogPromise=null;throw e;});
          const catalog=await catalogPromise;if(token!==generation)return;
          matches=catalog.filter(p=>{let rangeMatch=true;if(activeRange==='cube')rangeMatch=p.dimensions.length===3&&p.dimensions[0]===p.dimensions[1]&&p.dimensions[1]===p.dimensions[2];else if(activeRange&&activeRange!=='all'){const [min,max]=activeRange.split(':').map(Number);rangeMatch=p.dimensions[0]>=min&&p.dimensions[0]<=max;}return rangeMatch&&p.kind===current.kind&&(!current.color||p.colors.includes(current.color))&&(!current.quantity||p.quantities.includes(current.quantity))&&(!current.length||p.dimensions[0]===current.length)&&(!current.width||p.dimensions[1]===current.width)&&(current.kind==='mailers'||!current.height||p.dimensions[2]===current.height);}).sort((a,b)=>a.dimensions[0]-b.dimensions[0]||a.dimensions[1]-b.dimensions[1]||a.dimensions[2]-b.dimensions[2]);
          await loadBatch(token);
        }catch(e){if(token===generation){status.textContent=section.dataset.errorLabel;form.querySelector('button').disabled=false;}}
      });
      section.querySelectorAll('[data-sh-range]').forEach(button=>button.addEventListener('click',()=>{
        activeRange=button.dataset.shRange;
        section.querySelectorAll('[data-sh-range]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        form.elements.kind.value='boxes';
        for(const name of ['length','width','height','quantity'])form.elements.namedItem(name).value='';
        form.elements.color.value='';
        rangeSubmit=true;form.requestSubmit();
      }));
      more.addEventListener('click',()=>loadBatch(generation).catch(()=>{status.textContent=section.dataset.errorLabel;form.querySelector('button').disabled=false;more.hidden=false;}));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sh-variant-summary"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    document.querySelectorAll('[data-sh-variant-summary]').forEach(panel => {
      if (panel.dataset.shReady) return;
      panel.dataset.shReady = 'true';
      const local = panel.closest('.product-page, .shopify-section') || document;
      const picker = panel.querySelector('[data-sh-pack-select]');
      const details = panel.querySelector('[data-sh-pack-details]');
      let last = '';
      function update(id) {
        if (!id || last === String(id)) return;
        const tpl = panel.querySelector(`[data-sh-pack-template="${id}"]`);
        if (!tpl) return;
        last = String(id);
        details.replaceChildren(tpl.content.cloneNode(true));
        local.querySelectorAll('[data-sh-variant-row]').forEach(row => row.dataset.shSelected = String(row.dataset.shVariantRow === last));
      }
      if (picker) {
        update(picker.value);
        picker.addEventListener('change', () => {
          update(picker.value);
          const url = new URL(location.href); url.searchParams.set('variant', picker.value); history.replaceState({}, '', url);
        });
        local.addEventListener('focusin', e => { const row=e.target.closest('[data-sh-variant-row]'); if(row){picker.value=row.dataset.shVariantRow;update(picker.value);} });
      } else {
        const sync = () => {
          const control = local.querySelector('form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"], [data-js-product-variant-input]');
          update(control?.value || new URL(location.href).searchParams.get('variant'));
        };
        local.addEventListener('change', () => requestAnimationFrame(sync));
        window.setInterval(() => {if(panel.isConnected)sync();}, 500);
        sync();
      }
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
